<template>
  <div class="introduction-mask" v-show="visible">
    <div class="alert">
      <div class="title">Introduction</div>
      <div class="contents">
        <div class="introduce-desc" v-for="(item,index) in config.introduceTitle" :key="index">
            {{ item }}
        </div>
        <template v-for="item in config.introduceText">
            <div class="introduce-title">{{ item.title }}</div>
            <div class="introduce-item" v-for="el in item.text">
                {{ el }}
            </div>
        </template>
      </div>
    </div>
    <img class="close" src="@/assets/close.png" @click="visible = false">
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
      visible: false
    }
  }
}
</script>
<style lang="scss" scoped>
.introduction-mask{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.8);
  .alert{
    width: 730px;
    height: 485px;
    background: url(../assets/alert-bg.png);
    background-size: 100% 100%;
    .title{
      width: 100%;
      text-align: center;
      color: #fff;
      font-weight: 900;
      font-size: 22px;
      -webkit-text-stroke: 1px #000;
      margin-top: 24px;
    }
    .contents{
      margin-top: 20px;
      color: #000;
      padding: 0 40px;
      text-align: center;
      max-height: 400px;
      overflow: auto;
      .introduce-desc{
        font-size: 18px;
        font-weight: 500;
      }
      .introduce-title{
        margin-top: 20px;
        font-size: 18px;
        font-weight: 500;
      }
      .introduce-item{
        font-size: 18px;
      }
    }
  }
  .close{
    cursor: pointer;
    position: absolute;
    right: 525px;
    top: 200px;
    width: 70px;
    height: 70px;
  }
}
@media screen and (max-width: 768px) {
  .introduction-mask{
    .close{
      right: 0px;
      top: 540px;
    }
  }
}
</style>